import React, { FC } from 'react';
import { H3, H5 } from '../Element/Heading';
import Link from 'next/link';

// Define the type for a single link
interface LinkItem {
  href: string;
  title: string;
}

// Define the props for the LinkTable component
interface LinkTableProps {
  header: string;
  subheader: string;
  links: LinkItem[];
}

const LinkTable: FC<LinkTableProps> = ({ header, subheader, links }) => {
  return (
    <div className="flex flex-col items-center bg-gray-100 mb-6">
      <H3 className="mt-6 mb-2 hover:text-primary">
        <Link href={'/home-solar-guide'} legacyBehavior>
          {header}
        </Link>
      </H3>
      <H5>{subheader}</H5>
      <div className="flex justify-center bg-gray-100 ">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-10 max-w-4xl mx-auto">
          {links.map((link, index) => (
            <Link
              href={link.href}
              key={index}
              className="group block border bg-white hover:bg-blue-100 transition duration-300 rounded-lg p-6 transform hover:-translate-y-1 no-underline"
            >
              <span className="text-xl font-semibold text-gray-800 group-hover:text-blue-600">
                {link.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LinkTable;
